export default "__VITE_ASSET__D83E3go0__"